module.exports = __webpack_public_path__ + "static/media/logo-full.612cf5df.png";